<template>
  
  <div class="ui segment">

    <div :id="_uid" class="ui fluid accordion">  

      <h4 :id="_uid + '_title'" class="ui dividing header title">
        <i class="dropdown icon"></i>Filtros
      </h4>

      <div class="content active">
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">Data Inicial <span class="red text">*</span></label>
              <date-picker ref="startDatePicker" @onChange="onChangeStartDate" />
            </div>
            <div class="three wide field">
              <label class="form-label">Data Final <span class="red text">*</span></label>
              <date-picker ref="endDatePicker" @onChange="onChangeEndDate" />
            </div>
            <div class="five wide field">
              <label class="form-label">Clínica <span class="red text">*</span></label>
              <customer-picker ref="customerPicker" @onPick="onPickCustomer" @onClear="onClearCustomer" /> 
            </div>            
          </div>          
        </div>  
        <button class="ui blue button m-t-10" :class="{ disabled: !canApply }" @click="onApply()">
          <i class="check icon"></i> Aplicar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CertService from "@/services/cert-service"
  import { CustomerPicker, DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "DailyCertsFilter",

    data() {
      return {
        filter: {},
      }
    },

    components: {
      CustomerPicker,
      DatePicker,
      SelectDropdown,
    },

    mounted() {
      $(`#${this._uid}`).accordion()
    },

    computed: {
      canApply() {
        return (!!this.filter.startDate && !!this.filter.endDate && !!this.filter.customer)
      }
    },

    methods: {

      onChangeStartDate(date) {
        this.$set(this.filter, "startDate", date)
      },

      onChangeEndDate(date) {
        this.$set(this.filter, "endDate", date)
      },

      onPickCustomer(customer) {
        this.$set(this.filter, "customer", customer)
      },

      onApply() {

        $(`#${this._uid}_title`).click()

        this.$emit("onApply", this.$cloneObject(this.filter))
      },      

      onClearCustomer() {
        this.$set(this.filter, "customer", null)
      },

      clear() {

        this.filter = {}

        this.$refs.startDatePicker.clearDate(this.filter.startDate)
        this.$refs.endDatePicker.clearDate(this.filter.endDate)
        this.$refs.customerPicker.clear()

        $(`#${this._uid}_title`).click()
      },
    },
  }

</script>